import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { Core } from "@faire/design-tokens";
import { Column } from "@faire/web--source/slate/Layout";
import { Spacer } from "@faire/web--source/slate/spacing";
import { Typography } from "@faire/web--source/slate/Typography";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import React from "react";
import styled from "styled-components";
import { useLoggedOutContactUsContextStore } from "../hooks/LoggedOutContactUsContextStore";
import { useLoggedOutContactUsNavigation } from "../hooks/useLoggedOutContactUsNavigation";
import { useLoggedOutExperience } from "../hooks/useLoggedOutExperience";
import { useLoggedOutHelpCenterArticle } from "../hooks/useLoggedOutHelpCenterArticle";
import { useLoggedOutIssueType } from "../hooks/useLoggedOutIssueType";
import { Blurb } from "./Blurb";
import { ConditionalStepper } from "./ConditionalStepper";
import { Csat } from "./Csat";
import { useFilteredArticles } from "./hooks/useFilteredArticles";
import { SuggestedArticle } from "./SuggestedArticle";
export var ArticleLinksView = function ArticleLinksView() {
  var _useLoggedOutHelpCent = useLoggedOutHelpCenterArticle(),
    helpCenterArticles = _useLoggedOutHelpCent.helpCenterArticles;
  var _useLoggedOutIssueTyp = useLoggedOutIssueType(),
    issueType = _useLoggedOutIssueTyp.issueType;
  var _useLoggedOutContactU = useLoggedOutContactUsNavigation(),
    setFeedbackCollected = _useLoggedOutContactU.setFeedbackCollected,
    feedbackCollectedByIssueType = _useLoggedOutContactU.feedbackCollectedByIssueType;
  var _useLoggedOutContactU2 = useLoggedOutContactUsContextStore(["issueL2", "issueL3"]),
    _useLoggedOutContactU3 = _slicedToArray(_useLoggedOutContactU2, 1),
    _useLoggedOutContactU4 = _useLoggedOutContactU3[0],
    issueL2 = _useLoggedOutContactU4.issueL2,
    issueL3 = _useLoggedOutContactU4.issueL3;
  var _useLoggedOutExperien = useLoggedOutExperience(),
    isLoggedOutUserExperience = _useLoggedOutExperien.isLoggedOutUserExperience;
  var filteredArticles = useFilteredArticles(helpCenterArticles, issueL2, isLoggedOutUserExperience);
  return /*#__PURE__*/React.createElement(Column, {
    justify: "flex-start"
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "pageHeaderSerifRegular"
  }, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "oUNjX9",
    defaultMessage: [{
      "type": 0,
      "value": "Abbiamo chiarito i tuoi dubbi?"
    }]
  })), /*#__PURE__*/React.createElement(Spacer, {
    height: "2x"
  }), /*#__PURE__*/React.createElement(Blurb, {
    issueL3: issueL3,
    loggedOutExperience: isLoggedOutUserExperience
  }), /*#__PURE__*/React.createElement(Wrapper, null, filteredArticles.map(function (article, index) {
    return /*#__PURE__*/React.createElement(React.Fragment, {
      key: article.id
    }, /*#__PURE__*/React.createElement(SuggestedArticle, _objectSpread({}, article)), /*#__PURE__*/React.createElement(ConditionalStepper, {
      length: filteredArticles.length,
      index: index
    }));
  }), /*#__PURE__*/React.createElement(Csat, {
    feedbackCollectedByIssueType: feedbackCollectedByIssueType,
    issueType: issueType,
    setFeedbackCollected: setFeedbackCollected
  })), /*#__PURE__*/React.createElement(Spacer, {
    height: "3x"
  }));
};
var Wrapper = styled(Column).withConfig({
  displayName: "ArticleLinksView__Wrapper"
})(["padding:24px 18px;border:1px solid ", ";overflow-y:auto;max-height:430px;"], Core.border.muted);